export const FEATURE_FLAGS = {
  CHOICE_ENGINE_CASH_PICKUP: "choice-engine-cash-pickup",
  ACCOUNT_DETAILS: "account-details",
  NEW_SECURITY_QUESTIONS: "7501-new-security-questions",
  FX_RATES: 'fx-rates',
  BANK_ACCOUNTS: 'bank-accounts',
  PAYMENT_HISTORY: 'payment-history',
  CHANGE_ALLOCATION: 'change-allocation',
  COMPANION_CARD: 'companion-card',
  WAGE_STATEMENTS: 'wage-statements',
  WESTERN_UNION: 'western-union',
  WESTERN_UNION_TO_ACCOUNT_ENABLED: 'western-union-to-account-enabled',
  DISPLAY_CASH_PICKUP: 'display-cash-pickup',
  SEND_TO_BANK_ACCOUNT: 'send-bank-account',
  TOTP_DISPLAY_SETUP: 'TOTP_DisplaySetup',
  TOTP_DisplayDisable: 'TOTP_DisplayDisable',
  COMPANION_PARTICIPANT: 'companion-participant',
  ALLOW_PIN_CHANGE: 'allow-pin-change',
  ALLOW_CARD_TO_CARD_TRANSFER: 'allow-card-to-card-transfer',
  DISABLE_LOCK_UNLOCK_CARD: 'disable-lock-unlock-card',
  CANCEL_ON_DEMAND_TRANSFER: 'cancel-on-demand-transfer',
  DISPLAY_CURRENCY_CONVERTER: 'display-currency-converter',
  HAS_WESTERN_UNION_PROVIDER: 'western-union-provider-available',
  ENABLE_CREWLINK_BANNER: 'enable-crewlink-banner',
  SHOW_CARD_DETAILS_KILLSWITCH: 'show-card-details-killswitch',
  MC_TO_ACCOUNT: "mastercard-to-account-enabled",
  MC_MOBILE_WALLET: 'mastercard-to-mobile-wallet-enabled',
  PUSH_TO_CARD_ENABLED: 'push-to-card-enabled',
  RR_WEB_SDK_KILLSWITCH: 'rr-web-sdk-killswitch',
  RECENT_TRANSACTIONS_WEB_KILLSWITCH: 'recent-transactions-web-killswitch',
  SEND_MONEY_MOBILE_WALLET_ENABLE: 'send_money_mobile_wallet_enable'
};

export const CONDITIONS = {
  EMPLOYER_ID: "employer-id",
};

export const RR_SDK_FEATURE_FLAGS = [FEATURE_FLAGS.MC_TO_ACCOUNT, FEATURE_FLAGS.PUSH_TO_CARD_ENABLED, FEATURE_FLAGS.MC_MOBILE_WALLET];
